import axios from "axios";
import queryString from "query-string";
import { IBaseUrl, IGet, IPatch, IPost, IPut } from "./axios.interface";
import { GET_USER_TOKEN } from "./helper";

const { REACT_APP_API_URL } = process.env;
class HttpFacade {
  private http;
  constructor() {
    this.http = axios.create({
      baseURL: REACT_APP_API_URL,
      headers: { "Content-Type": "application/json" },
    });

    this.http.interceptors.request.use(
      (config) => {
        if (typeof window !== "undefined") {
          const token = GET_USER_TOKEN();
          if (token && config.headers) {
            config.headers.Authorization = "Bearer " + token;
          }
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
  }

  post = async ({ url, body }: IPost) => {
    const response = await this.http.post(url, body);
    return response.data;
  };

  patch = async ({ url, body }: IPatch) => {
    const response = await this.http.patch(url, body);
    return response.data;
  };

  get = async ({ url, query = {} }: IGet) => {
    const queryStringified = queryString.stringify(query);
    const response = await this.http.get(`${url}?${queryStringified}`);
    return response.data;
  };

  delete = async ({ url }: IBaseUrl) => {
    const response = await this.http.delete(url);
    return response.data;
  };

  put = async ({ url, body }: IPut) => {
    const response = await this.http.put(url, body);
    return response.data;
  };
}

export default new HttpFacade();
